import * as React from 'react';
import { Create, Form, Toolbar } from 'react-admin';
import { Card, CardContent } from '@mui/material';
import { useLocation } from 'react-router-dom';

import { MemberInputs } from './MemberInputs';

export const MemberCreate = () => {
    const location = useLocation();
    const antennaId = location.state?.antennaId;

    return (
        <Create actions={false} redirect="show" mutationMode="pessimistic">
            <Form
                defaultValues={{
                    type: 'VOLUNTEER',
                    since_date: new Date().toISOString(),
                    selectedAntennaIds: antennaId ? [antennaId] : [],
                }}
            >
                <Card>
                    <CardContent>
                        <MemberInputs />
                    </CardContent>
                    <Toolbar />
                </Card>
            </Form>
        </Create>
    );
};
